import { getAllFamilyPostion, updateFamilyMember } from 'config/Redux/action';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { formatDate, formatDateAsc, formatDateShort } from 'utils';
import { Input } from '..';
import Button from '../Button';

export default function EditProfile({ closeModal, idPasien, data }) {
  const jenisKelamin = [
    {
      name: 'Laki - Laki',
      value: 'male',
    },
    {
      name: 'Perempuan',
      value: 'female',
    },
  ];

  const [fullName, setFullName] = useState(data.fullname);
  const [tglLahir, setTglLahir] = useState(data.birthdate);
  const [relasi, setRelasi] = useState({
    id: data.family_position.id,
    name: data.family_position.name,
  });
  const [dataRelasi, setDataRelasi] = useState('');
  const [gender, setGender] = useState({
    id: data.gender,
    title: data.gender === 'male' ? 'Laki - Laki' : 'Perempuan',
  });

  const isLoading = useSelector((state) => state.isLoading);
  const dispatch = useDispatch();

  const _getRelationFamily = async () => {
    const relasi = await dispatch(
      getAllFamilyPostion('/staff/family-positions')
    );
    setDataRelasi(relasi);
  };

  const handleClickSimpan = async () => {
    const sendData = {};

    sendData._method = 'PATCH';
    sendData.fullname = fullName;
    sendData.gender = gender.id;
    sendData.birthdate = tglLahir;
    sendData.family_position_id = relasi.id;

    await dispatch(
      updateFamilyMember(`/staff/family-members/${idPasien}`, sendData)
    );

    closeModal();
    return window.location.reload();
  };

  useEffect(() => {
    _getRelationFamily();
  }, []);

  if (!dataRelasi) {
    return <p>Loading</p>;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-30">
      <div
        className="w-auto max-h-full bg-white flex flex-col py-16 px-12 relative z-30 "
        style={{ width: 420, minHeight: 306 }}
      >
        <div className="absolute top-5 right-7">
          <svg
            className="cursor-pointer"
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={closeModal}
          >
            <path
              d="M15.8199 13.0001L24.4199 4.42013C24.7965 4.04352 25.0081 3.53273 25.0081 3.00013C25.0081 2.46752 24.7965 1.95673 24.4199 1.58013C24.0433 1.20352 23.5325 0.991943 22.9999 0.991943C22.4673 0.991943 21.9565 1.20352 21.5799 1.58013L12.9999 10.1801L4.41988 1.58013C4.04327 1.20352 3.53248 0.991943 2.99988 0.991943C2.46727 0.991943 1.95649 1.20352 1.57988 1.58013C1.20327 1.95673 0.991694 2.46752 0.991694 3.00013C0.991694 3.53273 1.20327 4.04352 1.57988 4.42013L10.1799 13.0001L1.57988 21.5801C1.39242 21.7661 1.24363 21.9873 1.1421 22.231C1.04056 22.4747 0.988281 22.7361 0.988281 23.0001C0.988281 23.2642 1.04056 23.5256 1.1421 23.7693C1.24363 24.013 1.39242 24.2342 1.57988 24.4201C1.7658 24.6076 1.98701 24.7564 2.23072 24.8579C2.47444 24.9594 2.73585 25.0117 2.99988 25.0117C3.2639 25.0117 3.52531 24.9594 3.76903 24.8579C4.01275 24.7564 4.23395 24.6076 4.41988 24.4201L12.9999 15.8201L21.5799 24.4201C21.7658 24.6076 21.987 24.7564 22.2307 24.8579C22.4744 24.9594 22.7359 25.0117 22.9999 25.0117C23.2639 25.0117 23.5253 24.9594 23.769 24.8579C24.0128 24.7564 24.2339 24.6076 24.4199 24.4201C24.6073 24.2342 24.7561 24.013 24.8577 23.7693C24.9592 23.5256 25.0115 23.2642 25.0115 23.0001C25.0115 22.7361 24.9592 22.4747 24.8577 22.231C24.7561 21.9873 24.6073 21.7661 24.4199 21.5801L15.8199 13.0001Z"
              fill="#C8C8C8"
            />
          </svg>
        </div>
        <h4 className="font-inter font-semibold text-black1 mb-8">
          Ubah Profil
        </h4>

        <Input
          withOutline
          className="mb-6"
          label="Nama Lengkap"
          name="fullname"
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
        />

        <Input
          withDate
          name="tgl-lahir"
          label="Tanggal Lahir"
          className="mb-6"
          value={formatDateAsc(tglLahir)}
          onChange={(e) => setTglLahir(e.target.value)}
          fixValue={(value) => setTglLahir(value)}
        />

        <Input
          withDropdown
          options={dataRelasi}
          className="mb-6"
          label="Relasi Dalam Keluarga"
          name="relasi"
          value={relasi.name}
          onChange={(e) => setRelasi(e.target.value)}
          fixValue={(value) => setRelasi({ id: value.id, name: value.name })}
        />

        <Input
          withDropdown
          options={jenisKelamin}
          className="mb-6"
          label="Jenis Kelamin"
          name="gender"
          value={gender.title}
          onChange={(e) => setGender(e.target.value)}
          fixValue={(value) =>
            setGender({ id: value.value, title: value.name })
          }
        />

        <Button
          isDisabled={isLoading}
          title={`${isLoading ? 'Loading...' : 'Simpan'}`}
          className={`w-max rounded-3 mx-auto text-white ${
            isLoading
              ? 'bg-gray1 hover:bg-gray5 font-bold px-6 py-2.5'
              : 'bg-blue1 hover:bg-blue-400  font-bold px-6 py-2.5'
          }`}
          onClick={handleClickSimpan}
        />
      </div>
    </div>
  );
}
